import React, { Suspense, useEffect } from 'react';
import gql from 'graphql-tag';
import { ApolloProvider, useQuery } from '@apollo/client';
import { useSellerShippingPrice } from './UseSellerShippingPrice';
import SellerShippingPrice from './SellerShippingPrice';
import ReactDOM from 'react-dom';
const QUERY = gql `
  query SellerShippingPriceLoaderQuery($sellerContactId: String, $overseas: Boolean) {
    calculateSellerShippingPrice {
      calculateSellerShippingPrice(sellerContactId: $sellerContactId, overseas: $overseas) {
        locations {
          locationCode
          locationName
          baseShippingFees {
            locationCode
            locationName
            priceFrom
            priceTo
            shippingFee
          }
          additionalShippingFeesWeight {
            locationCode
            locationName
            referenceWeight
            shippingFee
            shippingFeePerAdditionalKilo
            shippingPlanDisplayId
          }
          additionalShippingFeesQuantity {
            locationCode
            locationName
            shippingFee
            shippingFeePerAdditionalQuantity
            shippingPlanDisplayId
          }
        }
      }
    }
  }
`;
const SellerShippingPriceLoader = (props) => {
    let { loading, error, data, refetch, fetchMore } = useQuery(QUERY, {
        variables: {
            sellerContactId: props.sellerContactId,
            overseas: props.overseas == 'true',
        },
    });
    let { updateLocations, tableConfig } = useSellerShippingPrice();
    useEffect(() => {
        if (data &&
            data.calculateSellerShippingPrice &&
            data.calculateSellerShippingPrice.calculateSellerShippingPrice &&
            data.calculateSellerShippingPrice.calculateSellerShippingPrice.locations) {
            updateLocations(data.calculateSellerShippingPrice.calculateSellerShippingPrice.locations);
        }
    }, [data]);
    if (loading)
        return React.createElement("div", null, "Loading");
    if (error)
        return React.createElement("div", null, error.message);
    return React.createElement(SellerShippingPrice, { tableConfig: tableConfig });
};
const renderSellerShippingPrice = (apolloClient) => {
    const itemShippingFeeListComponent = document.getElementById('aperza-item-shipping-fees-component');
    if (itemShippingFeeListComponent) {
        let sellerContactId = itemShippingFeeListComponent.dataset.sellerContactId;
        let overseas = itemShippingFeeListComponent.dataset.overseas;
        let lang = itemShippingFeeListComponent.dataset.lang;
        ReactDOM.render(React.createElement(ApolloProvider, { client: apolloClient },
            React.createElement(Suspense, { fallback: React.createElement("div", null) },
                React.createElement(SellerShippingPriceLoader, { sellerContactId: sellerContactId, overseas: overseas, lang: lang }))), itemShippingFeeListComponent);
        // ReactDOM.render(<ItemShippingFeeListComponent sellerContactId={sellerContactId} overseas={overseas} lang={lang}/>, itemShippingFeeListComponent);
    }
};
export { renderSellerShippingPrice };
